import { useAppStore } from '@/store';
import { cn } from '@/lib/utils';
import { CheckCircle2, XCircle, Info, AlertTriangle, X } from 'lucide-react';

const icons = {
  success: CheckCircle2,
  error:   XCircle,
  info:    Info,
  warning: AlertTriangle,
};

const styles = {
  success: 'bg-teal-800 border-teal-600 text-white',
  error:   'bg-red-700 border-red-500 text-white',
  info:    'bg-navy-800 border-navy-600 text-white',
  warning: 'bg-amber-700 border-amber-500 text-white',
};

export function Notifications() {
  const { notifications, removeNotification } = useAppStore();

  return (
    <div className="fixed bottom-5 right-5 z-[100] flex flex-col gap-2 pointer-events-none">
      {notifications.map(n => {
        const Icon = icons[n.type];
        return (
          <div
            key={n.id}
            className={cn(
              'flex items-start gap-3 px-4 py-3 rounded-xl border shadow-card-lg',
              'min-w-72 max-w-sm pointer-events-auto animate-slide-in',
              styles[n.type]
            )}
          >
            <Icon size={18} className="flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm">{n.title}</p>
              {n.message && <p className="text-xs opacity-80 mt-0.5">{n.message}</p>}
            </div>
            <button
              onClick={() => removeNotification(n.id)}
              className="opacity-60 hover:opacity-100 transition-opacity p-0.5"
            >
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
